import { Radio, RadioGroup } from '@headlessui/react';
import { FunctionComponent, InputHTMLAttributes, ReactNode } from 'react';
import { useController } from 'react-hook-form';
import { ErrorMessage } from 'softcat:components/error-message.tsx';
import { Form } from 'softcat:components/form.tsx';

type FormRadioGroupProperties = InputHTMLAttributes<Omit<HTMLInputElement, 'type'>> & {
    label: ReactNode;
    name: string;
    options: { label: string; value: string }[];
};

export const FormRadioGroup: FunctionComponent<FormRadioGroupProperties> = ({ label, name, options, ...fieldAttributes }) => {
    const { field, fieldState } = useController({ name });

    return (
        <div className="sm:grid sm:grid-cols-4 sm:items-start sm:gap-4">
            <Form.Label htmlFor={name}>{label}</Form.Label>

            <div className={'mt-2 sm:col-span-3 sm:mt-1.5'}>
                <RadioGroup {...field} {...fieldAttributes} className="inline-flex gap-4">
                    {options.map((option, index) => {
                        return (
                            <Radio
                                className={
                                    'flex cursor-pointer select-none items-center justify-center rounded-md bg-white px-4 py-2.5 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-gray-200 hover:bg-gray-50 data-[checked]:bg-indigo-600 data-[checked]:text-white data-[checked]:ring-0 data-[focus]:data-[checked]:ring-2 data-[focus]:ring-2 data-[focus]:ring-indigo-600 data-[focus]:ring-offset-2 data-[checked]:hover:bg-indigo-600 sm:flex-1'
                                }
                                key={`${index}-${option.value}`}
                                value={option.value}
                            >
                                {option.label}
                            </Radio>
                        );
                    })}
                </RadioGroup>

                {fieldState.error && (
                    <div className="mt-3">
                        <ErrorMessage>{fieldState.error.message}</ErrorMessage>
                    </div>
                )}
            </div>
        </div>
    );
};
